import { InviteEmailForm } from './InviteEmailForm'
import { withInviteEmailForm } from './withInviteEmailForm'

const ConnectedInviteEmailForm = withInviteEmailForm(InviteEmailForm)

export { ConnectedInviteEmailForm as InviteEmailForm }
